import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../utils/cn';
const variants = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700 focus-visible:ring-primary-500',
  secondary: 'bg-surface-inverse text-fg-inverse hover:bg-neutral-800 focus-visible:ring-neutral-500',
  outline:
    'border border-edge bg-surface text-fg-secondary hover:bg-surface-secondary focus-visible:ring-primary-500',
  ghost: 'text-fg-secondary hover:bg-surface-muted focus-visible:ring-primary-500',
  danger: 'border border-danger-300 bg-surface text-danger-600 hover:bg-danger-50 focus-visible:ring-danger-500',
};
const sizes = {
  sm: 'px-3 py-1.5 text-sm gap-1.5',
  md: 'px-4 py-2 text-sm gap-2',
  lg: 'px-5 py-2.5 text-base gap-2.5',
};
const Spinner = () => (
  <Loader2 size={16} className="animate-spin" aria-hidden="true" />
);
export const Button = React.forwardRef(function Button(props, ref) {
  const {
    variant = 'primary',
    size = 'md',
    loading = false,
    leadingIcon,
    trailingIcon,
    className,
    children,
    as,
    ...rest
  } = props;
  const classes = cn(
    'inline-flex items-center justify-center font-medium rounded-md transition-colors duration-150',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
    'disabled:opacity-50 disabled:pointer-events-none',
    variants[variant],
    sizes[size],
    loading && 'pointer-events-none',
    className,
  );
  const content = (
    <>
      {loading ? <Spinner /> : leadingIcon}
      {children}
      {!loading && trailingIcon}
    </>
  );
  if (as === 'a') {
    const { ...anchorProps } = rest;
    return (
      <a ref={ref} className={classes} {...anchorProps}>
        {content}
      </a>
    );
  }
  const { disabled, ...buttonProps } = rest;
  return (
    <button
      ref={ref}
      type="button"
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...buttonProps}
    >
      {content}
    </button>
  );
});
